<template>
  <v-row>
    <v-col 
      xl="6" 
      lg="6" 
      md="6" 
      sm="12"
      xs="12">

      <v-row>
        <v-col cols="12" class="pt-0">
          <device-detail-filter
            :moves="singleDevice.moves"
            @onFilterChange="onFilterChange"
            :moveId="moveId"
          />
        </v-col>
        <v-col cols="12" v-if="deviceMove">
          <device-details-move 
            :loading="deviceMoveLoading"
            :move="deviceMove"
          />
        </v-col>

        <v-col cols="12">
          <device-detail-info 
            :single-device="singleDevice"
            :loading="loadingDevices"
            :loading-new-refresh-rate="loadingNewRefreshRate"
            :update-refresh-rate-action="updateRefreshRateAction"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col 
      xl="6" 
      lg="6" 
      md="6" 
      sm="12"
      xs="12">

      <device-details-map 
        :loading="deviceLocationsLoading"
        :markers="markers"
        :circles="circles"
      />
    </v-col>
  </v-row>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
import DeviceDetailFilter from '@/components/devices/DeviceDetailFilter';
import DeviceDetailInfo from '@/components/devices/DeviceDetailInfo';
import DeviceDetailsMove from '@/components/devices/DeviceDetailsMove';
import DeviceDetailsMap from '@/components/devices/DeviceDetailsMap';
import { API_DATE_FORMAT } from '@/constants/date';
import { FULL_DATE_TIME_FORMAT } from '@/constants/date';
import dayjs from 'dayjs';
import * as actions from '@/store/actions.type';

export default {
  name: 'DeviceDetails',
  computed: {
    ...mapGetters([
      'singleDevice',
      'loadingDevices',
      'loadingNewRefreshRate',
      'deviceLocations',
      'deviceMove',
      'deviceMoveLoading',
      'deviceLocationsLoading'
    ]),
    deviceId() {
      return this.$route.params.id;
    },
    moveId() {
      return this.$route.query.moveId;
    },
    markers() {
      const markersArr = [];

      if(this.deviceLocations && this.deviceLocations.length) {
        this.deviceLocations.forEach((location, locationIndex) => {
          markersArr.push({
            id: locationIndex,
            position: {
              lat: location.latitude,
              lng: location.longitude,
            },
            title: location.address,
            info: `
              <div>
                ${this.$t('device.marker.batteryPerc', { value: location.batteryPercentage })}
              </div>
              <div>
                ${this.$options.filters.date(location.date, FULL_DATE_TIME_FORMAT)}
              </div>
              `
          })
        })
      }

      return markersArr;
    },
    circles() {
      const circlesArr = [];

      if(this.deviceMove) {
        if(this.deviceMove.origin) {
          circlesArr.push({
            id: `${this.deviceMove.moveId}_origin`,
            position: {
              lat: this.deviceMove.origin.latitude,
              lng: this.deviceMove.origin.longitude
            },
            radius: this.deviceMove.origin.geofencingRadius,
            type: 'origin'
          })
        }

        if(this.deviceMove.destination) {
          circlesArr.push({
            id: `${this.deviceMove.moveId}_destination`,
            position: {
              lat: this.deviceMove.destination.latitude,
              lng: this.deviceMove.destination.longitude
            },
            radius: this.deviceMove.destination.geofencingRadius,
            type: 'destination'
          })
        }
      }

      return circlesArr;
    }
  },
  mounted() {
    this.fetchSingleDeviceAction({ 
      deviceId: this.deviceId,
      loadAdditionalData: true,
      moveId: this.moveId,
      locationsFromDate: dayjs().subtract(7, 'day').format(API_DATE_FORMAT)
    })

    if(this.moveId) {
      this.fetchDeviceMoveDetailsAction(this.moveId);
    }
  },
  destroyed() {
    this.resetSingleDeviceStateAction();
  },
  methods: {
    ...mapActions({
      fetchSingleDeviceAction: actions.FETCH_SINGLE_DEVICE,
      resetSingleDeviceStateAction: actions.RESET_SINGLE_DEVICE_STATE,
      updateRefreshRateAction: actions.UPDATE_REFRESH_RATE,
      fetchDeviceLocationsAction: actions.FETCH_DEVICE_LOCATIONS,
      fetchDeviceMoveDetailsAction: actions.FETCH_DEVICE_MOVE_DETAILS
    }),
    onFilterChange (params) {
      this.fetchDeviceLocationsAction(params);
    }
  },
  components: {
    DeviceDetailInfo,
    DeviceDetailsMap,
    DeviceDetailFilter,
    DeviceDetailsMove
  }
}
</script>